<template>
  <CoverLayout v-if="dialogPromise">
    <div class="promise" slot="content">
      <i class="icon_close" @click="handleClose"></i>
      <div class="title">本人承诺</div>
      <div class="content">
        本人同意所有自填信息提交溯源优才—全国人力资源信息数据验证平台存储，本人对所有自
        填信息的内容真实性和完整性负责，如因信息有误或缺失造成的不良后果，本人愿意承担相
        应的法律责任。
      </div>
      <Btn btnText="我已了解并同意" :width="198" @handleClick="handleAgree" />
    </div>
  </CoverLayout>
</template>

<script>
import Btn from "./Btn.vue";
import CoverLayout from "./CoverLayout.vue";
import { firstWritePromise, getUserInfo } from "@/api/user";
export default {
  components: { CoverLayout, Btn },
  data() {
    return {
      dialogPromise: false
    };
  },
  methods: {
    handleShow() {
      console.log("handleShow");
      this.dialogPromise = true;
    },
    handleClose() {
      this.dialogPromise = false;
    },
    async getUserInfo() {
      await getUserInfo().then(res => {
        sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
      });
      return res.data.d;
    },
    handleAgree() {
      firstWritePromise().then(res => {
        if (res.data.c === 200) {
          this.dialogPromise = false;
          getUserInfo().then(res => {
            sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
            this.$emit("handleAgreePromise", res.data.d);
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.promise {
  background: #fff;
  position: relative;
  width: 464px;
  height: 302px;
  padding: 22px 74px 39px 74px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 16px;
  .icon_close {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileRemove.png");
    background-size: cover;
    width: 14px;
    height: 14px;
    display: inline-block;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #6e6e6e;
    line-height: 41px;
    text-align: center;
  }
  .content {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    line-height: 28px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promise.vue